export class OrderVm {
    BestillingsId: string = "";
    WrxNr: string = "";
    MyndighedsKode: string = "";
    OprettetDato: Date | null = null;
    Note: string = "";
    BestillingsStatus: string = "";
    Cpr: string = "";
    Fornavn: string = "";
    Efternavn: string = "";
    Cvr: string = "";
    CvrNavn: string = "";
}